
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaicabs() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Cabs',
    heading: 'AB Ghule Cabs: Pune to Mumbai Cabs',
    headingDescription: 'Traveling from Pune to Mumbai has never been more comfortable, affordable, and convenient than with AB Ghule Cabs. Our Pune to Mumbai cab service is designed to provide you with a seamless and stress-free journey. Whether you are heading to Mumbai for business, a family trip, or a weekend getaway, our fleet of well-maintained vehicles and professional drivers ensures a safe and enjoyable ride every time.',

    top: 'Top Places to Visit in Mumbai with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Gateway of India",
          description: "A majestic symbol of Mumbai’s colonial heritage, the Gateway of India stands tall by the Arabian Sea. This iconic monument was built to commemorate the visit of King George V and Queen Mary in 1911. The grand Indo-Saracenic architecture, with its arches and intricate carvings, makes it one of the most photographed landmarks in Mumbai. Visitors often use the Gateway as a starting point for ferries to the Elephanta Caves, making it a significant historical and cultural hub. The Gateway is a must-visit spot for those exploring Mumbai's rich past and bustling present."
        },
        {
          title: "Marine Drive",
          description: "Dubbed the 'Queen’s Necklace' due to its glowing streetlights that resemble a string of pearls, Marine Drive is one of Mumbai’s most famous promenades. Stretching along the Arabian Sea, it offers unparalleled views, especially at sunset. This curved boulevard is perfect for a leisurely walk or a peaceful drive, with refreshing sea breezes and the sound of waves. Marine Drive is a popular spot for both locals and tourists, providing a tranquil escape amidst the city’s hustle and bustle. It’s also an excellent place for couples, families, and photographers to capture stunning views of the Mumbai coastline."
        },
        {
          title: "Chhatrapati Shivaji Maharaj Terminus (CST)",
          description: "Chhatrapati Shivaji Maharaj Terminus, also known as CST or Victoria Terminus, is a UNESCO World Heritage Site and a striking example of Victorian Gothic Revival architecture. This historic railway station, built in 1887, is a key transportation hub in Mumbai and is renowned for its intricate stone carvings, pointed arches, and ornate detailing. As one of Mumbai's busiest stations, it represents the city's colonial past while also showcasing its importance in the modern era. Visitors will be amazed by the blend of architectural beauty and historical significance that make CST a top spot for history enthusiasts and architecture lovers."
        },
        {
          title: "Elephanta Caves",
          description: "A short ferry ride from the Gateway of India, Elephanta Caves is an ancient rock-cut temple complex dedicated to Lord Shiva. These UNESCO World Heritage-listed caves feature stunning sculptures and intricate carvings that showcase the excellence of ancient Indian art and architecture. The most famous sculpture is the Trimurti, a 20-foot high depiction of the three faces of Lord Shiva. The caves are not only a spiritual retreat but also a historical treasure, offering visitors an opportunity to explore ancient religious practices and marvel at the craftsmanship of the sculptures."
        },
        {
          title: "Siddhivinayak Temple",
          description: "Dedicated to Lord Ganesha, Siddhivinayak Temple is one of Mumbai’s most famous and revered religious sites. The temple attracts thousands of devotees from across the country, especially during festivals like Ganesh Chaturthi. The temple’s elegant architecture, with its golden dome and intricate carvings, adds to its spiritual significance. Siddhivinayak Temple is renowned for its peaceful atmosphere, where visitors come not only to seek blessings but also to witness the devotion of the local community. For those visiting Mumbai, it’s a must-see for both spiritual and architectural reasons."
        },
        {
          title: "Haji Ali Dargah",
          description: "Situated on a small islet off the coast of Worli, Haji Ali Dargah is a stunning example of Indo-Islamic architecture. The dargah is dedicated to Haji Ali, a wealthy merchant who renounced his riches and devoted his life to serving the poor. The path to the dargah, which stretches across the sea and is only accessible during low tide, offers a mesmerizing experience as visitors walk over the water. The tranquil ambiance, coupled with the beautiful architecture and the surrounding views of the sea, makes Haji Ali Dargah a unique and spiritual destination in Mumbai."
        },
        {
          title: "Colaba Causeway",
          description: "Colaba Causeway is Mumbai’s vibrant shopping street, known for its mix of quirky shops, ethnic jewelry, fashionable clothes, and street vendors selling a variety of goods. The street is a haven for shoppers and those looking for unique items at reasonable prices. It is also home to iconic eateries like Leopold Cafe, where visitors can enjoy a hearty meal while soaking in the lively atmosphere. Colaba Causeway’s blend of shopping, dining, and historical architecture makes it a must-visit spot for anyone exploring the local culture and lifestyle of Mumbai."
        },
        {
          title: "Juhu Beach",
          description: "Juhu Beach is one of Mumbai’s most popular and vibrant beaches, famous for its lively atmosphere and mouthwatering street food. It is a favorite spot for locals and tourists alike who come to relax, take a walk, or enjoy the sunset while savoring classic Mumbai delicacies like vada pav and pav bhaji. The beach is also famous for its bustling activity, with children playing in the sand, families enjoying picnics, and locals participating in evening walks or yoga. Whether you're looking for a lively beach experience or simply a place to unwind, Juhu Beach offers the perfect combination of fun and relaxation."
        },
        {
          title: "Bandra-Worli Sea Link",
          description: "An engineering marvel, the Bandra-Worli Sea Link is a cable-stayed bridge that connects the western suburbs of Bandra to South Mumbai. The bridge’s sleek design and towering pylons make it an architectural wonder, and it offers stunning views of the Mumbai skyline, especially when lit up at night. The Bandra-Worli Sea Link has become an iconic symbol of modern Mumbai and is considered a testament to the city's infrastructural progress. Driving across the bridge provides a unique experience, with breathtaking views of the sea and the city, making it a must-see for anyone visiting Mumbai."
        },
        {
          title: "Film City",
          description: "Bollywood's heart and soul, Film City is a sprawling complex where movies and TV shows are filmed. Located in Goregaon, Mumbai, it offers guided tours that take visitors behind the scenes of the Indian film industry. Visitors can explore film sets, studios, and other facilities where famous Bollywood productions are brought to life. A trip to Film City is a must for cinema lovers who want to experience the magic of Indian film-making firsthand. With its grand sets, star-studded atmosphere, and cinematic allure, Film City provides an unforgettable experience for fans of Bollywood."
        }
      ],


  services: [
    {
      "name": "Pune to Mumbai Cab Service",
      description: "AB Ghule Cabs offers a reliable and convenient Pune to Mumbai cab service, providing you with a smooth and stress-free ride. Whether you are traveling for business, leisure, or need an airport transfer, we ensure comfort and punctuality. Our fleet consists of well-maintained vehicles with experienced drivers to ensure your journey is pleasant and on-time."
    },
    {
      "name": "Affordable Cabs Pune to Mumbai",
      description: "If you're looking for an affordable cab from Pune to Mumbai, AB Ghule Cabs provides excellent value for your money. Our pricing is transparent with no hidden charges, allowing you to travel comfortably at an affordable rate. We provide economical options without compromising on quality, ensuring a satisfying experience for our customers."
    },
    {
      "name": "AB Ghule Cabs",
      description: "AB Ghule Cabs is a trusted name in the taxi service industry in Pune and Mumbai. We offer premium travel solutions with a variety of vehicles tailored to suit all your needs. From short trips within the city to long-distance outstation rides, we are committed to offering you top-notch service, punctuality, and comfort."
    },
    {
      "name": "Luxury Cabs Pune to Mumbai",
      description: "Indulge in luxury with our high-end cabs for your Pune to Mumbai journey. At AB Ghule Cabs, we offer luxury vehicles equipped with the latest amenities to ensure a comfortable and sophisticated ride. Whether you're attending a business event or enjoying a leisure trip, our luxury cabs provide a plush travel experience with attentive service."
    },
    {
      "name": "Pune to Mumbai Cheapest Cab",
      description: "AB Ghule Cabs offers the cheapest taxi service from Pune to Mumbai without compromising on the quality of your ride. Our budget-friendly options make it easier for you to travel comfortably on a budget. Enjoy timely and reliable service at the most competitive prices in the market."
    },
    {
      "name": "Pune Mumbai Taxi Service",
      description: "For a dependable and punctual taxi service from Pune to Mumbai, AB Ghule Cabs is your go-to choice. Whether it's a one-way trip or a return journey, our fleet of well-maintained taxis and professional drivers ensure you have a seamless travel experience. Book your ride with us and enjoy a smooth, hassle-free trip."
    },
    {
      "name": "Pune to Mumbai Airport Cabs",
      description: "Need a cab for your airport transfer from Pune to Mumbai? AB Ghule Cabs specializes in providing efficient and reliable airport transfers, ensuring you reach Mumbai Airport on time. Our taxi service offers comfortable vehicles and professional drivers to ensure that your airport journey is smooth and stress-free."
    },
    {
      "name": "Pune to Mumbai Outstation Cabs",
      description: "Going on an outstation trip from Pune to Mumbai? AB Ghule Cabs provides convenient and reliable outstation cabs with a range of vehicles to suit your travel needs. Whether you need a one-way trip or a round trip, our experienced drivers will ensure you travel in comfort. Book your outstation cab with us for a hassle-free journey."
    },
    {
      "name": "Pune to Mumbai Cab Booking Online",
      description: "With AB Ghule Cabs, booking a taxi from Pune to Mumbai has never been easier. You can easily book your ride online through our user-friendly platform. Choose from a variety of vehicle options, customize your journey according to your preferences, and enjoy a smooth booking experience."
    },
    {
      "name": "Pune Mumbai Express Taxi",
      description: "For those in a rush, AB Ghule Cabs offers express taxi services from Pune to Mumbai. We prioritize punctuality and fast travel to ensure you reach your destination on time. With an express service, you can expect minimal delays and efficient service throughout your journey."
    },
    {
      "name": "Pune to Mumbai Private Cabs",
      description: "If you prefer privacy and exclusivity, AB Ghule Cabs offers private cabs for your trip from Pune to Mumbai. Our private taxi service allows you to travel without interruptions and enjoy a more personalized experience. Choose from our fleet of premium vehicles for a quiet, comfortable, and private journey."
    },
    {
      "name": "Pune Mumbai One-Way Taxi",
      description: "If you're looking for a one-way taxi ride from Pune to Mumbai, AB Ghule Cabs offers one-way fares that are perfect for those who need to travel in one direction without returning. Our one-way taxis are available at competitive rates, ensuring you only pay for the distance you travel."
    },
    {
      "name": "Pune to Mumbai Round Trip Cabs",
      description: "For those planning a round-trip journey from Pune to Mumbai, AB Ghule Cabs provides flexible and affordable round-trip taxi services. Whether you need to travel back the same day or over multiple days, our round-trip service offers comfort and convenience, with the same professional drivers available for both legs of your journey."
    },
    {
      "name": "Pune to Mumbai Cabs",
      description: "AB Ghule Cabs is committed to offering top-quality taxi services for your Pune to Mumbai travel needs. Our fleet includes a variety of vehicles to suit your preferences, from economy cars to luxury taxis. We provide a safe, comfortable, and hassle-free experience for both business and leisure travelers."
    },
    {
      "name": "Pune to Mumbai Airport Cab Fare",
      description: "The fare for a Pune to Mumbai airport cab with AB Ghule Cabs is both competitive and transparent. We offer affordable pricing with no hidden charges, so you can be confident that you're getting the best value for your money. Our airport transfer services guarantee timely and reliable travel."
    },
    {
      "name": "Pune Mumbai Airport Drop",
      description: "If you're heading to Mumbai Airport, AB Ghule Cabs offers a smooth and reliable airport drop service from Pune. Our drivers are professional, punctual, and ensure that you arrive at the airport with plenty of time before your flight, making sure your journey is stress-free."
    },
    {
      "name": "Pune to Mumbai Cheapest Cab",
      description: "Looking for an affordable cab from Pune to Mumbai? AB Ghule Cabs offers the cheapest options in town, making it easier for you to travel without exceeding your budget. We offer great deals while ensuring you get a comfortable and timely service."
    },
    {
      "name": "Pune to Mumbai Cab Service",
      description: "AB Ghule Cabs provides a comprehensive Pune to Mumbai cab service, whether you're commuting for work, attending an event, or exploring the city. Our service is tailored to your travel needs, offering reliable drivers and well-maintained vehicles for a smooth ride."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      description: "With AB Ghule Cabs, you are assured of the best cab service from Pune to Mumbai. Our fleet of vehicles, professional drivers, and focus on customer satisfaction make us a leading choice for travelers who value comfort, reliability, and quality service."
    },
    {
      "name": "Pune to Mumbai Cab Fare",
      description: "At AB Ghule Cabs, we offer affordable and transparent pricing for your Pune to Mumbai cab fare. Our goal is to provide a competitive and budget-friendly service without compromising the comfort and safety of our passengers."
    },
    {
      "name": "Pune Mumbai Taxi Service",
      description: "AB Ghule Cabs is the preferred choice for many when it comes to Pune Mumbai taxi services. Our professional and courteous drivers ensure a comfortable, timely, and safe ride to and from Mumbai, making your travel experience enjoyable and hassle-free."
    },
    {
      "name": "Pune to Mumbai Car",
      description: "If you're looking to hire a car from Pune to Mumbai, AB Ghule Cabs has a fleet of well-maintained vehicles available. From budget options to premium cars, we offer a wide variety to suit your preferences and budget."
    },
    {
      "name": "Pune Mumbai Taxi Fare",
      description: "The fare for your Pune Mumbai taxi ride with AB Ghule Cabs is calculated fairly, ensuring you get great value. We believe in offering competitive rates while maintaining high-quality service standards. With no hidden charges, you can be confident that you're getting a transparent and affordable experience."
    },
    {
      "name": "Pune to Mumbai International Airport Cab",
      description: "For a seamless journey to Mumbai International Airport, choose AB Ghule Cabs. Our professional drivers are familiar with the fastest routes and airport procedures, ensuring you arrive with plenty of time before your flight, without stress or delays."
    },
    {
      "name": "Pune to Mumbai Cab Price",
      description: "AB Ghule Cabs offers affordable pricing for Pune to Mumbai trips. The cab price depends on factors like the type of vehicle chosen, time of booking, and any special requests you may have, but we guarantee competitive pricing that suits your budget."
    },
    {
      "name": "Pune to Mumbai Airport Cab Price",
      description: "Traveling from Pune to Mumbai airport? Our taxi fare for this service is designed to be budget-friendly, with no surprise charges. AB Ghule Cabs ensures you get a fair price while providing top-notch service for your airport journey."
    },
    {
      "name": "Pune to Mumbai Taxi One Way",
      description: "For a one-way trip from Pune to Mumbai, AB Ghule Cabs offers an economical and efficient taxi service. You can travel in comfort without the burden of paying for a return trip, and our professional drivers ensure you get to your destination without delays."
    },
    {
      "name": "Pune to Mumbai Cab Booking",
      description: "Booking a cab from Pune to Mumbai is quick and easy with AB Ghule Cabs. Whether you prefer to book online or via phone, our customer service team is always ready to assist with your booking, ensuring a smooth and hassle-free process."
    },
    {
      "name": "Pune to Mumbai Airport Taxi",
      description: "Need a taxi from Pune to Mumbai airport? AB Ghule Cabs offers reliable and punctual airport transfer services. Our drivers will pick you up from your location and make sure you get to Mumbai airport on time, providing comfort throughout the journey."
    },
    {
      "name": "Pune Mumbai Cab One Way",
      description: "If you're looking for a one-way cab ride from Pune to Mumbai, AB Ghule Cabs offers a cost-effective solution. Whether it's for business or leisure, we provide an efficient service that gets you to your destination quickly and comfortably."
    },
    {
      "name": "Pune to Mumbai Cabs Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Mumbai Cabs. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],


tableData: [
  ["Pune to Mumbai Cab Service", "-Affordable Cabs Pune to Mumbai"],
  ["AB Ghule Cabs", "-Luxury Cabs Pune to Mumbai"],
  ["Pune to Mumbai cheapest cab", "-Pune Mumbai Taxi Service"],
  ["Pune to Mumbai Airport Cabs", "-Pune to Mumbai Outstation Cabs"],
  ["Pune to Mumbai Cab Booking Online", "-Pune Mumbai Express Taxi"],
  ["Pune to Mumbai Private Cabs", "-Pune Mumbai One-Way Taxi"],
  ["Pune to Mumbai Round Trip Cabs", "-Pune to Mumbai Cabs"],
  ["Pune to Mumbai Airport cab", "-Pune Mumbai Cab"],
  ["Pune to Mumbai Taxi", "-Pune to Mumbai Airport Cab Fare"],
  ["Pune Mumbai Airport Drop", "-Pune to Mumbai Cheapest Cab"],
  ["Pune to Mumbai Cab Service", "-Best Cab Service Pune to Mumbai"],
  ["Pune to Mumbai cab fare", "-Pune Mumbai Taxi Service"],
  ["Pune to Mumbai car", "-Pune Mumbai Taxi Fare"],
  ["Pune to Mumbai International Airport Cab", "-Pune to Mumbai Cab Price"],
  ["Pune to Mumbai Airport Cab Price", "-Pune to Mumbai Taxi One Way"],
  ["Pune to Mumbai Cab Booking", "-Pune to Mumbai Airport Taxi"],
  ["Pune Mumbai Cab One Way", ""]
],

whychoose: [
  {
    WhyChooseheading: "Reliable and Timely Service",
    WhyChoosedescription: "AB Ghule Cabs offers punctual and reliable cab services for your Pune to Mumbai journey. Our drivers are well-trained to ensure that you arrive on time, whether it's for business, leisure, or an airport transfer."
  },
  {
    WhyChooseheading: "Comfortable and Spacious Vehicles",
    WhyChoosedescription: "We offer a wide variety of vehicles, including sedans, SUVs, and luxury cars, ensuring that you travel in comfort and style. Our vehicles are well-maintained, ensuring a smooth ride with ample space for all passengers and luggage."
  },
  {
    WhyChooseheading: "Experienced and Professional Drivers",
    WhyChoosedescription: "Our drivers are highly skilled and experienced, with extensive knowledge of the Pune to Mumbai route. They are courteous, background-checked, and committed to providing you with a safe and pleasant journey."
  },
  {
    WhyChooseheading: "Affordable Pricing with No Hidden Charges",
    WhyChoosedescription: "AB Ghule Cabs offers competitive rates for Pune to Mumbai trips, with a transparent pricing structure. You’ll always know the cost upfront, with no hidden charges or surprises."
  },
  {
    WhyChooseheading: "24/7 Availability",
    WhyChoosedescription: "Whether you're traveling early in the morning or late at night, our services are available round-the-clock to accommodate your needs. You can rely on us for a convenient and hassle-free booking experience at any time."
  },
  {
    WhyChooseheading: "Well-Maintained Fleet",
    WhyChoosedescription: "We take great pride in maintaining our vehicles in excellent condition. All our cars are thoroughly cleaned and regularly serviced to ensure your comfort and safety throughout the journey."
  },
  {
    WhyChooseheading: "Easy Booking Process",
    WhyChoosedescription: "Booking a cab for your Pune to Mumbai trip is easy and fast. You can use our website, mobile app, or call our customer service to make a booking at your convenience."
  },
  {
    WhyChooseheading: "Safe and Comfortable Rides",
    WhyChoosedescription: "We prioritize your safety, with GPS-equipped vehicles and experienced drivers. Enjoy a secure and comfortable ride from Pune to Mumbai, with ample legroom and air-conditioning."
  }
]

  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Pune to Mumbai cab with AB Ghule Cabs?',
      answer: 'You can book a cab through our website, mobile app, or by calling our customer service. We offer a simple and fast booking process for your convenience.',
    },
    {
      id: 'FAQ2',
      question: 'Are the drivers experienced for Pune to Mumbai trips?',
      answer: 'Yes, all our drivers are highly experienced and familiar with the Pune to Mumbai route. They ensure safe and efficient travel, no matter the time of day.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for booking for Pune to Mumbai trips?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars, to suit your preferences and travel needs. Choose from our comfortable and well-maintained fleet.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my Pune to Mumbai ride?',
      answer: 'Payment options include cash, credit/debit cards, and online payments through our mobile app or website. Choose the payment method that’s most convenient for you.',
    },
    {
      id: 'FAQ5',
      question: 'Do you provide airport transfers from Pune to Mumbai?',
      answer: 'Yes, we offer reliable and timely airport transfers. Whether you are traveling from Pune to Mumbai airport or vice versa, our drivers will ensure you reach your destination on time.',
    },
    {
      id: 'FAQ6',
      question: 'Are there any extra charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours. However, we always provide clear and transparent pricing so you know what to expect before confirming your booking.',
    },
    {
      id: 'FAQ7',
      question: 'Can I book a cab for a round trip from Pune to Mumbai?',
      answer: 'Yes, you can book a round trip from Pune to Mumbai. Simply mention your return trip details during the booking process, and we will tailor the service to suit your needs.',
    },
    {
      id: 'FAQ8',
      question: 'Is there a limit on luggage for Pune to Mumbai trips?',
      answer: 'We have a standard luggage allowance, but additional baggage or special requirements can be accommodated upon request. Please inform us during the booking process.',
    },
    {
      id: 'FAQ9',
      question: 'Can I get a cab for a group or family trip from Pune to Mumbai?',
      answer: 'Yes, we offer larger vehicles like SUVs and minivans to accommodate family or group travel. Whether it’s a small group or a larger family, we have suitable vehicles for your journey.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs the best option for Pune to Mumbai travel?',
      answer: 'AB Ghule Cabs stands out for its professional drivers, reliable service, affordable pricing, and well-maintained vehicles. We focus on providing a comfortable, safe, and enjoyable ride for every passenger.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Arvind Patel',
      feedback: 'I had a business meeting in Mumbai and needed a ride from Pune. AB Ghule Cabs made the trip seamless. The driver was on time, the car was clean and comfortable, and the whole experience was stress-free. I\'ll definitely use them for my next trip!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Anita Desai',
      feedback: 'I booked a Pune to Mumbai cab with AB Ghule Cabs for a family trip, and we were very impressed. The driver was courteous, the car was spacious, and we had a smooth journey. It was the best decision to choose them for our travel!',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable</title>
  <meta name="description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable" />
  <meta property="og:description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Mumbai Cabs",
        description: "Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "priceRange": "₹1500 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1500"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sneha Kulkarni"
            },
            "datePublished": "2024-12-22",
            "reviewBody": "Seamless booking process and the ride was very comfortable. Highly recommend AB Ghule Cabs for Pune to Mumbai trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vishal Sharma"
            },
            "datePublished": "2024-12-18",
            "reviewBody": "Great service at an affordable price. The driver was professional and punctual."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-mumbai-cabs"
        },
        "keywords": "Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/15.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetomumbaicabs;